import React, { memo, type ReactNode } from 'react';
import { type DatasourceCellValue } from '../content-column-read.ts';
import { type JiraIssueDetailsReadContent } from './jira-issue-details-read-content.ts';
import styles from './jira-issue-details-value-view.module.css';

/** Preserves the independent V1 Jira list, missing-column and image-size behavior. */
export const JiraIssueDetailsValueView = memo(function JiraIssueDetailsValueView({
  content,
  renderValue
}: {
  readonly content: JiraIssueDetailsReadContent;
  readonly renderValue: (value: DatasourceCellValue) => ReactNode;
}) {
  if (!content.items.length) {
    return null;
  }

  return (
    <ul
      className={`${styles.value} ${content.isPriority ? styles.priority : styles.description}`}
    >
      {content.items.map(({ key, column }) =>
        column.value ? <li key={key}>{renderValue(column.value)}</li> : null
      )}
    </ul>
  );
});
